import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchOrden, editOrden } from "../../actions/ordenesActions";
import { fetchPlanesPorParametros } from "../../actions/planesActions";
import { fetchTiposAdquirientes } from '../../actions/tiposActions';
import PropTypes from 'prop-types';

class MedioDePago extends Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            show: false,
            modalData: {
                nroPlan: "",
                montoCuota: "",
                recargo: "",
                idTransaccion: "",
                primerosSeisDigitos: "",
                ultimosCuatroDigitos: "",
                nroCupon: "",
                idAdquiriente: ""
            }
        }
    }

    componentDidUpdate = prevProps => {
        if (this.state.didEdit) {
            this.props.fetchOrden(this.props.idOrden);
            this.setState({
                didEdit: false
            })
        }
    }

    render() {
        const cupones = this.props.orden?.pago?.cupones;
        const verDetalleCupones = [1, 2, 3, 4].includes(Number(this.props.tipoUsuario));

        let datosDelPlan = null;
        let comision = null;

        if (verDetalleCupones && Array.isArray(cupones) && cupones.length > 0) {
            datosDelPlan = cupones.map((item, index) => (
                <div key={item.nroCupon ?? index}>
                    <div className="list-group-item hover-background-color" >
                        <div className="row">
                            <div className="col-md-3 col-lg-3">
                                <small className="font-14 applyFont"><label>Medio de pago: </label> {item.metodoPago ?? item.MetodoPago ?? "—"}</small>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Nro Plan: </small>
                                <span>{item.nroPlan}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Cuotas: </small>
                                <span>{item.cuotas}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Tarjeta: </small>
                                <span>{item.tarjeta}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Importe: </small>
                                <span>{item.montoCuota}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Banco: </small>
                                <span>{item.banco}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Autorización: </small>
                                <span>{item.autorizacion != null ? "$" + item.autorizacion : ""}</span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Nro Cupón: </small>
                                <span>{item.nroCupon}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Últimos 4 digitos: </small>
                                <span>{item.ultimosCuatroDigitos}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">Adquirente: </small>
                                <span>{item.adquiriente}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">ID Transacción: </small>
                                <span>{item.idTransaccion}</span>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <small style={{ fontWeight: "600", color: "#495057" }} className="font-14 applyFont">BIN: </small>
                                <span>{item.primerosSeisDigitos}</span>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
            ));
        }

        if (this.props.tipoUsuario !== 2) {
            comision = (
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <h6 className="box-title m-b-5 font-weight-bold" >Datos de la comisión </h6>
                        <div className="row">
                            <div className="col-md-6 col-lg-6 align-self-center">
                                <small className="font-14 applyFont"><label>Tipo publicación: </label>{this.props.orden?.tipoPublicacion?.tipo}</small>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
            );
        }

        return (
            <div className="tab-pane p-20 active " name="datos" id="home2" role="tabpanel">
                {datosDelPlan}
                {comision}
            </div>
        );
    }
}
MedioDePago.propTypes = {
    // Redux props
    idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    orden: PropTypes.shape({
        pago: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
            cupones: PropTypes.array,
        })]),
        tipoPublicacion: PropTypes.shape({
            tipo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
    tipoUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // Actions props
    fetchOrden: PropTypes.func,
}

const mapStateToProps = state => ({
    orden: state.ordenes.orden,
    tipoUsuario: state.general.tipoUsuario,
    planes: state.planes.planesPorParametros,
    propTiposAdquirientes: state.tipos.adquirientes
});
export default connect(mapStateToProps, {
    fetchTiposAdquirientes,
    fetchOrden,
    editOrden,
    fetchPlanesPorParametros
})(MedioDePago);
